import { useState, useMemo, useCallback } from 'react';

export type TradingTaskType = 'MANUAL_PREMIUM' | 'RIF_SELL';

interface UseTradingTaskFormProps {
  botTokens: Record<string, string[]>;
}

export const useTradingTaskForm = ({ botTokens }: UseTradingTaskFormProps) => {
  const [taskType, setTaskType] = useState<TradingTaskType>('MANUAL_PREMIUM');
  const [selectedBotId, setSelectedBotId] = useState<string>('');
  const [token, setToken] = useState('RIF');
  const [quantity, setQuantity] = useState('');
  
  // Premium specific
  const [premiumAmount, setPremiumAmount] = useState<number | ''>('');
  const [premiumCurrency, setPremiumCurrency] = useState<string>('USDT');
  const [premiumPrice, setPremiumPrice] = useState<number>(1);

  // Smart Sell specific
  const [activationPrice, setActivationPrice] = useState('');
  const [limitPrice, setLimitPrice] = useState('');

  // Target selector (dipster vs dumper)
  const [targetInstance, setTargetInstance] = useState<'dipster' | 'dumper'>('dipster');

  const isPremium = taskType === 'MANUAL_PREMIUM';
  const isSmartSell = taskType === 'RIF_SELL';

  const availableTokens = useMemo(() => {
    if (selectedBotId) {
      return botTokens[selectedBotId] || ['RIF', 'RDOC', 'USDT'];
    }
    return ['RIF', 'RDOC', 'USDT'];
  }, [selectedBotId, botTokens]);

  const resetForm = useCallback(() => {
    setSelectedBotId('');
    setToken('RIF');
    setQuantity('');
    setPremiumAmount('');
    setPremiumCurrency('USDT');
    setPremiumPrice(1);
    setActivationPrice('');
    setLimitPrice('');
  }, []);

  return {
    taskType,
    setTaskType,
    selectedBotId,
    setSelectedBotId,
    token,
    setToken,
    quantity,
    setQuantity,
    premiumAmount,
    setPremiumAmount,
    premiumCurrency,
    setPremiumCurrency,
    premiumPrice,
    setPremiumPrice,
    activationPrice,
    setActivationPrice,
    limitPrice,
    setLimitPrice,
    targetInstance,
    setTargetInstance,
    isPremium,
    isSmartSell,
    availableTokens,
    resetForm,
  };
};
